import React from 'react'

import styled from 'styled-components'

import {
  ExternalLinkWrapper,
  StyledLinkLarge,
  TitleXXL
} from 'src/components/blocks/Typography'
import { ResponsiveSectionWrapper } from 'src/components/partials/Section'
import { Breakpoints } from 'src/utilities/Breakpoints'
import { BrandColors, BrandTokens } from 'src/utilities/Colors'

import Button, { BrandButton } from '../partials/Button'
import { Grid, Column } from '../partials/Grid'

const G2SectionWrapper = styled(ResponsiveSectionWrapper)`
  ${TitleXXL} {
    text-align: center;
    margin-bottom: 2rem;

    @media (min-width: ${Breakpoints.sm}px) {
      margin-top: 0;
    }

    @media (min-width: ${Breakpoints.lg}px) {
      text-align: left;
    }
  }
  ${StyledLinkLarge} {
    display: inline-block;
    margin-inline: auto;
    margin-bottom: 0.5rem;
  }
  ${ExternalLinkWrapper} {
    display: block;
    margin-top: 1.75rem;
  }
`

const TextWrapper = styled(Column)`
  text-align: center;

  @media (min-width: ${Breakpoints.lg}px) {
    text-align: left;
  }
`

const ImageWrapper = styled(Column)`
  position: relative;

  .badges {
    display: block;
    height: auto;
    max-width: 100%;
    margin-inline: auto;

    @media (min-width: ${Breakpoints.lg}px) {
      margin-right: unset;
      margin-left: auto;
    }
  }
`

// const ImageMask = styled.div<{ backgroundColor: string }>`
//   position: absolute;
//   width: 125px;
//   height: 192px;
//   top: 0px;
//   right: 0;
//   display: none;
//   background: linear-gradient(
//     270deg,
//     ${props => props.backgroundColor} 0%,
//     rgba(29, 31, 74, 0) 74.4%
//   );
//   @media (min-width: ${Breakpoints.md}px) {
//     display: block;
//   }
// `

export const G2Banner = ({
  backgroundColor = BrandTokens.backgroundDark,
  showCta = true
}: {
  backgroundColor?: string
  showCta?: boolean
}) => (
  <G2SectionWrapper
    backgroundColor={backgroundColor}
    paddingLarge='6rem 0 6rem'
    paddingSmall='4rem 0 4rem'
  >
    <Grid container columns={{ lg: 3 }}>
      <TextWrapper>
        <TitleXXL as='h2' color={BrandColors.white} fontSizeMobile={1.5}>
          Our customers are our biggest fans
        </TitleXXL>
        {showCta && (
          <BrandButton
            color={BrandColors.white}
            inverted
            label='Read case studies'
            role='secondary'
            to='/resources/case-studies/'
          />
        )}
      </TextWrapper>

      <ImageWrapper span={{ lg: 2 }}>
        <img
          loading='lazy'
          alt='Flatfile G2 badges'
          className='badges'
          width={672}
          height={153}
          src={`/img/shared/g2-badges-2025-winter.webp`}
        />
        {/* <ImageMask backgroundColor={backgroundColor} /> */}
      </ImageWrapper>
    </Grid>
  </G2SectionWrapper>
)
